import "owl.carousel";
import Util from "../helpers/util";
import favUtil from "../helpers/favutil";
import GoogleMapsApi from "../helpers/GoogleMapsApi";

var UtilObject = new Util();
var favObject = new favUtil();
var GoogleMapsApiObjectVendor = new GoogleMapsApi();

let category;
let vendors, picklistID;
var deviceTypeHomePage;
var customerFavList = 0;

import { getImageUrl, getVendorBusinessImageUrl } from "../helpers/mediaUrl";
import { buildVendorCard } from "../helpers/cardComponents";

const getRatingColor = (rating) => {
  return rating > 0 ? "#48c479" : "#db7c38";
};

const getRatingScore = (rating) => {
  return rating == null || rating == 0 ? "New" : String(rating);
};

// buildVendorCard is now imported from cardComponents.js

export default class VendorListing {
  constructor() {
    this.grid = $(".vendorListingPage");
    category = $("div.vendorListingPage").attr("name");
    
    var screenWidthHp = $(window).width();
    deviceTypeHomePage = screenWidthHp < 768 ? "mobile" : "desktop";

    this.bindEvents();
  }

  bindEvents = () => {
    // Trigger immediately instead of waiting for load
    this.calOwlCarousel(); 
    this.getCategoryDetails();
    this.syncFavourites();

    // Filters Desktop
    $(".clearPriceFilterBtn").on("click", this.clearPriceFilterDesktop);
    $(".clearRatingFilterBtn, .Mobile-filter-clear-rating").on("click", this.clearRatingFilter);
    $(".clearDistanceFilterBtn").on("click", this.clearDistanceFilterDesktop);
    $(".clearDeliverytypeFilterBtn").on("click", this.clearDeliverytypeFilterDesktop);
    $(".clearMinorderFilterBtn").on("click", this.clearMinorderFilterDesktop);
    $(".clearSpecialityFilterBtn").on("click", this.clearSpecialityFilterDesktop);

    $(".selectPriceFilterBtn").on("click", this.selectPriceFilterDesktop);
    $(".selectRatingFilterBtn").on("click", this.selectRatingFilter);
    $(".selectDistanceFilterBtn").on("click", this.selectDistanceFilterDesktop);
    $(".selectDeliverytypeFilterBtn").on("click", this.selectDeliverytypeFilterDesktop);
    $(".selectMinorderFilterBtn").on("click", this.selectMinorderFilterDesktop);
    $(".selectSpecialityFilterBtn").on("click", this.selectSpecialityFilterDesktop);

    // Filters Mobile
    $(".Mobile-filter-clear-price").on("click", this.clearPriceFilterMobile);

    $(".applyFilterBtn").on("click", this.applyFilter);
    $(".clearAllFilterBtn").on("click", this.clearAllFilter);

    // Rating card toggle (no checkbox — uses .selected class on label)
    $(document).on("click", ".rating-filter-item.filter-checkbox", function () {
      $(this).toggleClass("selected");
    });
  };

  showVendorListingSkeleton = () => {
    $(".vendor-listing-skeleton").removeClass("d-none");
    $(".vendorListingPage").addClass("d-none");
  };

  hideVendorListingSkeleton = () => {
    $(".vendor-listing-skeleton").addClass("d-none");
    $(".vendorListingPage").removeClass("d-none");
  };

  buildSkeletonGrid = (count = 8) => {
    let skeletons = "";
    for (let i = 0; i < count; i++) {
      skeletons += `
            <div class="col-6 col-md-4 col-lg-3 mb-4">
                <div class="homepage-skeleton-vendor-card" style="border-radius: 16px; overflow: hidden; background: #fff; border: 1px solid #f0f0f0;">
                    <div class="homepage-skeleton-image homepage-skeleton-shimmer" style="height: 160px; width: 100%;"></div>
                    <div class="p-3">
                        <div class="homepage-skeleton-line w-80 homepage-skeleton-shimmer mb-2"></div>
                        <div class="homepage-skeleton-line w-60 homepage-skeleton-shimmer"></div>
                    </div>
                </div>
            </div>`;
    }
    return skeletons;
  };

  calOwlCarousel = () => {
    $(".carousel_se_1_carousel").owlCarousel({
      nav: true,
      dots: false,
      mouseDrag: true,
      responsive: {
        0: { items: 3 },
        480: { items: 3 },
        767: { items: 4 },
        992: { items: 5 },
        1200: { items: 6 },
      },
    });
  };

  getCategoryDetails = async () => {
    $.ajax({
      url: globalThis.baseURL + "api/customer/VendorsList/getCategoryDetails",
      type: "POST",
      data: { category: category },
      headers: { Authorization: globalThis.X_API_KEY },
      success: (result) => {
        if (!result || result.length === 0) {
          this.hideVendorListingSkeleton();
          $(".noVendors").removeClass("d-none");
          return;
        }
        this.showOnVendorListingPage(result);
      },
      error: () => {
        this.hideVendorListingSkeleton();
        $(".noVendors").removeClass("d-none");
      },
    });
  };

  showOnVendorListingPage = async (result) => {
    picklistID = result[0].Picklist_ID;

    // Load Top Specialities (Initial View)
    $.ajax({
      url: globalThis.baseURL + "api/customer/VendorsList/getSpecialities",
      type: "POST",
      data: { Picklist_parent_ID: result[0].Picklist_ID },
      headers: { Authorization: globalThis.X_API_KEY },
      success: (res) => {
        const carousel = $(".owl-carousel.top-specialities-items");
        if (carousel.hasClass("owl-loaded")) {
          const len = carousel.find(".owl-item").length;
          for (let i = 0; i < len; i++) {
            carousel.owlCarousel("remove", 0);
          }
        }

        $(".v-pills-speciality-items").empty();
        $(".mobile-filter-speciality-items").empty();

        if (res && res.length > 0) {
          $(".top-specialities").show();
          res.forEach((element) => {
            const categoryImg = getImageUrl(element.Icon_Url);
            const item = `
              <div class="item speciality-click-item ${element.Picklist_ID}" role="button" value="${element.Picklist_ID}">
                <div class="col-md-12 d-flex justify-content-center">
                  <div class="text-center">
                    <div class="rounded-circle mb-2 speciality-img-wrapper" style="width: 64px; height: 64px; background: #fff; border: 1px solid #f0f0f0; display: flex; align-items: center; justify-content: center; overflow: hidden; margin: 0 auto; transition: all 0.2s;">
                      <img class="speciality-thumb ${element.Picklist_ID}-specialityImage" src="${categoryImg}" alt="${element.Picklist_display_value}" style="width: 44px; height: 44px; object-fit: contain;">
                    </div>
                    <h6 class="truncate-one pt-1" style="font-size: 0.75rem; font-weight: 500;">${element.Picklist_display_value}</h6>
                  </div>
                </div>
              </div>`;

            carousel.owlCarousel("add", item);

            const filterItem = `<div class="form-check">
              <input class="form-check-input filter-checkbox speciality" type="checkbox" value="${element.Picklist_display_value}" data-filter-type="speciality" id="spec-${element.Picklist_ID}" />
              <label class="form-check-label" for="spec-${element.Picklist_ID}">${element.Picklist_display_value}</label>
            </div>`;
            $(".v-pills-speciality-items").append(filterItem);
            $(".mobile-filter-speciality-items").append(filterItem);
          });
          carousel.owlCarousel("update");
          $(".speciality-click-item").off("click").on("click", this.getSpeciality);
        } else {
          $(".top-specialities").hide();
        }
      }
    });

    // Load Min/Max for Filter Sidebar
    $.ajax({
      url: globalThis.baseURL + "api/customer/VendorsList/getMinMaxAmountForVendor",
      type: "POST",
      data: { Category_ID: result[0].Picklist_ID },
      headers: { Authorization: globalThis.X_API_KEY },
      success: (res) => {
        $(".v-pills-minorder-items").empty();
        $(".mobile-filter-minorder-items").empty();
        if (res && res[0]) {
          let min = parseInt(res[0].minimum);
          let max = parseInt(res[0].maximum);
          let interval = Math.max(50, parseInt((max - min) / 5));
          while (min < max) {
            const minItems = `<div class="form-check">
              <input class="form-check-input filter-checkbox minorder" type="checkbox" value="${min}-${min + interval}" data-filter-type="minorder" id="min-${min}" />
              <label class="form-check-label" for="min-${min}">Rs ${min} - Rs ${min + interval}</label>
            </div>`;
            $(".v-pills-minorder-items").append(minItems);
            $(".mobile-filter-minorder-items").append(minItems);
            min += interval;
          }
        }
      }
    });

    this.hideVendorListingSkeleton();
    $(".vendorListingPage").removeClass("d-none");

    // Load Initial "Trending" Vendors (Discovery State)
    this.getInitialVendors(result[0].Picklist_ID);
  };

  getInitialVendors = (categoryId) => {
    const container = $(".trending-vendors-items");
    container.html(`
        <div class="col-12 text-center py-5">
            <div class="spinner-border text-danger" role="status"><span class="sr-only">Loading...</span></div>
        </div>
    `);

    $.ajax({
      url: globalThis.baseURL + "api/customer/VendorsList/getVendorWithMainFilter",
      type: "POST",
      data: { 
        lat: globalThis.LAT, 
        lon: globalThis.LNG, 
        buffer: globalThis.BUFFER, 
        Picklist_ID: categoryId, 
        Condition_1: "", 
        DeliveryCondition: "", 
        SpecialityCondition: "" 
      },
      headers: { Authorization: globalThis.X_API_KEY },
      success: (res) => {
        const vendors = Array.isArray(res) ? res : Object.values(res);
        container.empty().css('opacity', 0);
        if (!vendors.length) {
            $(".trending-vendors, .noVendors").addClass("d-none");
        } else {
            $(".trending-vendors").removeClass("d-none");
            $(".noVendors").addClass("d-none");
            vendors.slice(0, 12).forEach(v => {
                const fav = this.checkFavouriteSync(v.Vendor_ID);
                container.append(buildVendorCard(v, { favBtn: fav, isCarousel: false }));
            });
            container.animate({ opacity: 1 }, 400);
            $(".likeBtnHomepage").off("click").on("click", this.setFavourites);
        }
      }
    });
  };

  getSpeciality = (event) => {
    const specialityID = event.currentTarget.getAttribute("value");
    
    $(".speciality-img-wrapper").removeClass("border-danger border-2 shadow-sm").css("background", "#fff");
    $(event.currentTarget).find(".speciality-img-wrapper").addClass("border-danger border-2 shadow-sm").css("background", "#fff5f6");

    $(".noVendors, .near-you, .away-from-you, .trending-vendors, .vendor-results").addClass("d-none");
    $(".near-you-items, .away-from-you-items").empty();

    const scrollToResults = (target) => {
        const headerOffset = 130;
        if (target && target.length) {
            const elementPosition = target.offset().top;
            window.scrollTo({ top: elementPosition - headerOffset, behavior: "smooth" });
        }
    };

    $.ajax({
      url: globalThis.baseURL + "api/customer/VendorsList/getVendorBySpecialities",
      type: "POST",
      data: { 
        buffer: globalThis.BUFFER, 
        lat: globalThis.LAT, 
        lon: globalThis.LNG, 
        Picklist_ID: specialityID 
      },
      headers: { Authorization: globalThis.X_API_KEY },
      success: (res) => {
        if (!res || (res.NearMeCount + res.AwayfromMeCount === 0)) {
          $(".noVendors").removeClass("d-none");
          $(".vendor-results").addClass("d-none");
          $(".total").html(0);
          scrollToResults($(".noVendors"));
        } else {
          $(".vendor-results").removeClass("d-none");
          $(".total").html(res.NearMeCount + res.AwayfromMeCount);
          if (res.NearMeCount > 0) {
            $(".near-you").removeClass("d-none");
            res.NearMe.forEach(el => {
              const fav = this.checkFavouriteSync(el.Vendor_ID);
              $(".near-you-items").append(buildVendorCard(el, { favBtn: fav, isCarousel: false }));
            });
          }
          if (res.AwayfromMeCount > 0) {
            $(".away-from-you").removeClass("d-none");
            res.AwayfromMe.forEach(el => {
              const fav = this.checkFavouriteSync(el.Vendor_ID);
              $(".away-from-you-items").append(buildVendorCard(el, { favBtn: fav, isCarousel: false }));
            });
          }
          $(".likeBtnHomepage").off("click").on("click", this.setFavourites);
          scrollToResults($(".vendor-results"));
        }
      },
      error: () => {
        $(".noVendors").removeClass("d-none");
        scrollToResults($(".noVendors"));
      }
    });
  };

  // Filter Methods
  clearPriceFilterDesktop = () => $("#v-pills-price :checkbox").prop("checked", false);
  clearRatingFilter = (e) => {
    if (e) e.preventDefault();
    $(".rating-filter-item.filter-checkbox").removeClass("selected");
  };
  clearDistanceFilterDesktop = () => $("#v-pills-distance :checkbox").prop("checked", false);
  clearDeliverytypeFilterDesktop = () => $("#v-pills-deliverytype :checkbox").prop("checked", false);
  clearMinorderFilterDesktop = () => $("#v-pills-minorder :checkbox").prop("checked", false);
  clearSpecialityFilterDesktop = () => $("#v-pills-speciality :checkbox").prop("checked", false);

  clearRatingFilterMobile = () => $(".mobile-filter-rating .filter-checkbox").removeClass("selected");

  selectPriceFilterDesktop = () => $("#v-pills-price :checkbox").prop("checked", true);
  selectRatingFilter = (e) => {
    if (e) e.preventDefault();
    $(".rating-filter-item.filter-checkbox").addClass("selected");
  };
  selectDistanceFilterDesktop = () => $("#v-pills-distance :checkbox").prop("checked", true);
  selectDeliverytypeFilterDesktop = () => $("#v-pills-deliverytype :checkbox").prop("checked", true);
  selectMinorderFilterDesktop = () => $("#v-pills-minorder :checkbox").prop("checked", true);
  selectSpecialityFilterDesktop = () => $("#v-pills-speciality :checkbox").prop("checked", true);

  clearAllFilter = () => {
    $("input[type=checkbox]").prop("checked", false);
    $(".filter-checkbox").removeClass("selected");
    $(".vendor-results, .noVendors").addClass("d-none");
    this.getCategoryDetails();
  };

  applyFilter = (event) => {
    let filter = { rating: [], distance: [], deliverytype: [], minorder: [], speciality: [] };
    const viewType = $(event.currentTarget).hasClass("desktop-main-filter") ? "Desktop" : "Mobile";
    const container = viewType === "Desktop" ? "#exampleModalScrollableDesktop" : "#exampleModalScrollableMobile";

    // Collect selected rating card labels (no checkbox)
    $(`${container} .rating-filter-item.filter-checkbox.selected`).each((i, el) => {
      // Backend expects arrays of values: [["5"], ["4"]]
      filter.rating.push([$(el).data("value").toString()]);
    });

    // Collect all other checkbox-based filters
    $(`${container} .filter-checkbox:checked`).each((i, el) => {
      const type = $(el).data("filter-type");
      if (type && filter.hasOwnProperty(type)) {
        filter[type].push(el.value.split("-"));
      }
    });

    this.getVendorByFilter(filter);
    
    // Bootstrap 5 Modal API
    const modalElement = document.querySelector(`#exampleModalScrollable${viewType}`);
    if (modalElement) {
        const modalInstance = bootstrap.Modal.getInstance(modalElement) || new bootstrap.Modal(modalElement);
        modalInstance.hide();
    }
  };

  getVendorByFilter = (filter) => {
    $.ajax({
      url: globalThis.baseURL + "api/customer/VendorsList/getVendorWithMainFilter",
      type: "POST",
      data: { 
        lat: globalThis.LAT, 
        lon: globalThis.LNG, 
        buffer: globalThis.BUFFER, 
        Picklist_ID: picklistID, 
        filters: JSON.stringify(filter) 
      },
      headers: { Authorization: globalThis.X_API_KEY },
      success: (res) => {
        const vendors = Array.isArray(res) ? res : Object.values(res);
        $(".total").html(vendors.length);
        
        $(".trending-vendors, .noVendors, .near-you, .away-from-you").addClass("d-none");
        $(".vendor-results").removeClass("d-none");
        $(".near-you-items").empty();

        if (!vendors.length) {
          $(".noVendors").removeClass("d-none");
          $(".vendor-results").addClass("d-none");
        } else {
          $(".near-you").removeClass("d-none");
          vendors.forEach(v => $(".near-you-items").append(buildVendorCard(v, { favBtn: this.checkFavouriteSync(v.Vendor_ID), isCarousel: false })));
          $(".likeBtnHomepage").off("click").on("click", this.setFavourites);
        }
      }
    });
  };

  setFavourites = async (event) => {
    var vendorID = event.currentTarget.value;
    var result, type;
    if (event.currentTarget.classList.contains("liked")) {
      result = await favObject.favouritesToggle(vendorID, "false");
      type = 0;
    } else {
      result = await favObject.favouritesToggle(vendorID, "true");
      type = 1;
    }

    if (result == "YOU NEED TO LOG IN") {
      window.$("#favouritesError").modal("show");
    } else if (result == "ERROR OCCURED") {
    } else {
      $(`button.like-button[value='${vendorID}']`).toggleClass("liked");
      const icon = type == 1 ? "heart-suit" : "filled-like";
      const pkg = type == 1 ? "emoji" : "material-outlined";
      $(`button.like-button[value='${vendorID}']`).html(`<img src="https://img.icons8.com/${pkg}/48/null/${icon}.png"/>`);
      this.syncFavourites();
    }
  };

  syncFavourites = async () => {
    const cookies = UtilObject.getAllCookies();
    if (!cookies.hasOwnProperty("CUSTOMER_ID")) {
      this.favSet = new Set();
      return;
    }

    try {
      const result = await $.ajax({
        url: globalThis.baseURL + "api/customer/Account/getFavorites",
        type: "GET",
        headers: { Authorization: globalThis.X_API_KEY },
      });
      this.favSet = new Set(result.map(item => item.Vendor_ID));
    } catch {
      this.favSet = new Set();
    }
  };

  checkFavouriteSync = (id) => {
    const isLiked = this.favSet && this.favSet.has(id);
    const icon = isLiked ? "heart-suit" : "filled-like";
    const pkg = isLiked ? "emoji" : "material-outlined";
    return `<button class="like-button likeBtnHomepage ${isLiked ? "liked" : ""} zindex-popover" aria-label="Favourite" value="${id}">
      <img src="https://img.icons8.com/${pkg}/48/null/${icon}.png"/>
    </button>`;
  };
}